import React from "react";
import { cn } from "../utils";

export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn(`w-full mx-auto px-[10px] md:max-w-[490px] lg:max-w-[1000px] xl:max-w-[1232px]
      `, className)}>
      {children}
    </div>
  );
};
